import type { ConsentText } from './types';

/** The plot consent in Hindi - follows en.ts key for key and placeholder for placeholder (see types.ts). */
export const hi: ConsentText = {
  selfName: 'हिन्दी',
  englishName: 'अंग्रेज़ी',
  labels: {
    stageDraft: 'किसान के पढ़ने के लिए - अभी हस्ताक्षर नहीं हुए',
    stagePaper: 'किसान के हस्ताक्षर के लिए',
    stageSigned: 'सहमति दी गई',
    watermark: 'ड्राफ्ट',
    kindDraft: 'ड्राफ्ट सहमति',
    kindPaper: 'काग़ज़ पर सहमति',
    kindDigital: 'डिजिटल सहमति',
    record: 'रिकॉर्ड',
    page: 'पृष्ठ',
    generated: '{at} को तैयार किया गया',
    title: 'किसान की अपने प्लॉट के लिए सहमति',
    plot: 'प्लॉट',
    valid: 'मान्य',
    validRange: '{from} से {to} तक',
    membershipOfGroup: 'किसान उत्पादक समूह की सदस्यता',
    farmerHeading: '1. किसान',
    name: 'नाम',
    memberCode: 'सदस्य कोड',
    fatherOrSpouse: 'पिता / पति या पत्नी',
    gender: 'लिंग',
    age: 'आयु',
    address: 'पता',
    mobile: 'मोबाइल',
    email: 'ईमेल',
    consentLanguage: 'सहमति की भाषा',
    programmesHeading: 'यह सहमति किन कार्यक्रमों के लिए है',
    certificateReference: 'प्रमाणपत्र / संदर्भ',
    validUntil: '{date} तक मान्य',
    inScope: '{org} के दायरे में',
    membership: 'सदस्यता',
    membershipValue: 'यह प्लॉट {org} के किसान उत्पादक समूह के हिस्से के रूप में',
    agreeFarmer: 'मैं, {name}, पुष्टि करता/करती हूँ कि ऊपर दिया गया विवरण मेरा है और सही है। आगे के पृष्ठों में मेरे प्लॉट, मेरी जानकारी, और हर उस कार्यक्रम के लिए मैं किस बात पर सहमत हूँ, इसका वर्णन है जिसमें मेरा प्लॉट शामिल है। ये बातें मुझे {languages} में समझाई गईं, जो मैं समझता/समझती हूँ, और मैं यह सहमति अपनी मर्ज़ी से, बिना किसी दबाव के देता/देती हूँ। मैं कभी भी इसे वापस लेने के लिए कह सकता/सकती हूँ।',
    plotHeading: '2. प्लॉट',
    village: 'गाँव',
    location: 'स्थान',
    centre: 'बीच का बिंदु (अक्षांश, देशांतर)',
    notMapped: 'सीमा का नक्शा अभी नहीं बना',
    declaredArea: 'घोषित क्षेत्रफल (भूमि रिकॉर्ड)',
    mappedArea: 'नक्शे से मापा गया क्षेत्रफल',
    tenure: 'भूमि का स्वामित्व / कब्ज़े का प्रकार',
    landDocuments: 'भूमि के दस्तावेज़',
    trees: 'प्लॉट पर पेड़',
    excision: 'अलग रखे गए क्षेत्र (घोषित)',
    boundaryHeading: 'सीमा (GPS, अक्षांश, देशांतर)',
    snapshotCaption: 'उपग्रह चित्र पर सीमा',
    moreCorners: '... {n} और कोने, ऐप में सुरक्षित',
    agreePlot: 'मैं सहमत हूँ कि पृष्ठ 1 पर लिखे कार्यक्रमों के लिए {org} इस प्लॉट का पंजीकरण कर सकता है, इसका नक्शा बना सकता है और इसकी निगरानी कर सकता है।',
    dataHeading: '3. मेरी भागीदारी और मेरी जानकारी',
    dutiesHeading: 'कार्यक्रमों में भागीदार के रूप में, मैं सहमत हूँ कि मैं',
    informationHeading: 'मेरे बारे में रखी जाने वाली जानकारी',
    collected: 'क्या जानकारी ली जाती है',
    why: 'क्यों',
    whoReceives: 'मेरी जानकारी किसे मिल सकती है',
    howLong: 'कितने समय तक रखी जाती है',
    myRights: 'मेरे अधिकार',
    toAsk: 'पूछने, शिकायत करने या सहमति वापस लेने के लिए',
    dataBoard: 'यदि समाधान न हो, तो मैं भारत के डेटा संरक्षण बोर्ड (Data Protection Board of India) से शिकायत कर सकता/सकती हूँ।',
    agreeData: 'मैं सहमत हूँ कि इस सहमति में बताए गए उद्देश्यों के लिए मेरी जानकारी ली और इस्तेमाल की जाए।',
    sharingHeading: '4. मेरी जानकारी का इस्तेमाल और साझा कैसे किया जा सकता है',
    withdrawingHeading: 'अपनी सहमति वापस लेना',
    iAgreeTo: 'मैं सहमत हूँ कि मैं',
    iAmEntitled: 'मुझे यह अधिकार है',
    agreeScope: 'मैंने समझ लिया है कि प्लॉट {plot} के लिए {scope} मुझसे क्या अपेक्षा करता है, और मैं इससे सहमत हूँ।',
    recordHeading: 'सहमति का रिकॉर्ड',
    consent: 'सहमति',
    consentValue: '{scopes} के लिए प्लॉट की सहमति',
    farmer: 'किसान',
    recordId: 'रिकॉर्ड आईडी',
    givenByOtp: 'OTP द्वारा दी गई सहमति',
    otpRef: 'OTP संदर्भ',
    documentSha: 'दस्तावेज़ SHA-256',
    signatureOf: '{name} के हस्ताक्षर',
    thumb: 'अंगूठा',
    witness: 'गवाह (नाम और हस्ताक्षर)',
    date: 'तारीख़',
    witnessFull: 'गवाह का नाम और हस्ताक्षर',
    officerFull: 'फील्ड अधिकारी का नाम और हस्ताक्षर',
    paperNote: 'काग़ज़ पर दी गई: किसी गवाह के सामने यहाँ और हर पृष्ठ पर हस्ताक्षर करें या अंगूठे का निशान लगाएँ। फील्ड अधिकारी यह हस्ताक्षरित प्रति अपलोड करेंगे।',
    otpSentence: '{name} की सहमति {reached} पर भेजे गए OTP से ली गई और {day} को {time} बजे{by} सत्यापित की गई।',
    otpBy: ' {officer} द्वारा',
    registeredMobile: 'पंजीकृत मोबाइल',
    registeredEmail: 'पंजीकृत ईमेल',
    via: 'के ज़रिए',
    and: 'और',
    registeredContact: 'पंजीकृत संपर्क',
    coversHeading: 'यह सहमति किन बातों के लिए है',
    partiesHeading: 'किसान के साथ यह सहमति देने वाले व्यक्ति',
    relationship: 'रिश्ता',
    termsHeading: 'व्यवस्था की शर्तें',
    termsBlank: 'उपज या बिक्री की रकम में हिस्सा: ______ %    भुगतान किसे: ________________',
    partiesBlank: 'नाम हाथ से लिखे जाएँ, हर नाम के नीचे उस व्यक्ति के हस्ताक्षर हों।',
    bothVersions: 'यह दस्तावेज़ अंग्रेज़ी में और किसान की अपनी भाषा, यानी इस भाषा में है। दोनों एक ही सहमति हैं; सहमति किसान को इसी भाषा में समझाई गई थी।',
    partySignature: '{name} के हस्ताक्षर या अंगूठा',
    partiesNote: 'यहाँ लिखा हर व्यक्ति किसी गवाह के सामने काग़ज़ की प्रति के इस पृष्ठ पर हस्ताक्षर करता है; किसान OTP या हस्ताक्षर से सहमति देता है।',
  },
  kinds: {
    sale: {
      title: 'किसान की अपने प्लॉट की उपज की कटाई और बिक्री के लिए सहमति',
      heading: 'इस प्लॉट से कटाई और बिक्री',
      about: 'यह सहमति प्लॉट {plot} पर कटाई और उसकी उपज - इमारती लकड़ी, बल्ली, लुगदी की लकड़ी, जलाऊ लकड़ी, बाँस या अन्य उपज - को {org} के ज़रिए बेचने के लिए है, और यह भी कि हर बिक्री का रिकॉर्ड और भुगतान कैसे होगा।',
      agreeLead: 'मैं सहमत हूँ कि मैं',
      obligations: [
        'कटाई केवल {org} के आंतरिक कटाई परमिट और क़ानून के अनुसार ज़रूरी पेड़ काटने और लकड़ी ले जाने (ट्रांज़िट) के परमिट के साथ ही करूँ, और केवल निशान लगे पेड़ और तय मात्रा ही काटूँ।',
        'हर कटाई की प्रजाति, पेड़ों की संख्या और आयतन या वज़न सच-सच बताऊँ, और उसे इस प्लॉट के नाम पर नापने, फ़ोटो लेने और दर्ज करने दूँ।',
        'इस प्लॉट की जिस उपज पर प्रमाणन या वनों की कटाई से मुक्त (deforestation-free) होने का दावा है, उसे केवल {org} या उसके बताए ख़रीदार को ही बेचूँ, और उसमें कहीं और की उपज कभी न मिलाऊँ।',
        'हर बिक्री इनवॉइस, डिस्पैच डॉकेट और ट्रांज़िट के काग़ज़ों के साथ दर्ज करवाऊँ, और हर बिक्री की मात्रा और रकम की पुष्टि अपने OTP या हस्ताक्षर से करूँ।',
        '{org} को प्लॉट, कटाई और बिक्री का वह विवरण साझा करने दूँ जिसकी ज़रूरत किसी ख़रीदार, प्रमाणन संस्था या सरकारी अधिकारी को उपज को इस प्लॉट तक पहचानने के लिए हो।',
        'तय की गई कटौतियाँ - कटाई और ढुलाई का ख़र्च, अग्रिम राशि, खाद-बीज आदि के क़र्ज़ और समूह शुल्क - बिक्री की रकम से काटने दूँ, जैसा मेरे खाते के विवरण में दिखाया जाए।',
        'कटाई के बाद, प्रबंधन योजना के अनुसार, दोबारा पेड़ लगाऊँ या प्राकृतिक रूप से उगने दूँ।',
        'पेड़ों, ज़मीन या उपज को लेकर कोई भी विवाद हो तो बिक्री से पहले तुरंत {org} को बताऊँ।',
      ],
      rightsLead: 'मुझे यह अधिकार है',
      rights: [
        'हर बिक्री की पुष्टि करने से पहले उसका भाव, मात्रा, कटौतियाँ और मिलने वाली शुद्ध रकम जानना, और इनवॉइस की एक प्रति पाना।',
        '{org} द्वारा तय समय के अंदर शुद्ध रकम अपने ही बैंक खाते में पाना, और हर भुगतान अपने खाते के विवरण में देखना।',
        'जिस बिक्री का भाव या मात्रा मुझे मंज़ूर न हो, उसे मना करना।',
        'अपने प्लॉट से हुई किसी भी बिक्री के रिकॉर्ड माँगना।',
      ],
      agree: 'मैं, {name}, इन शर्तों पर प्लॉट {plot} की उपज की कटाई और बिक्री के लिए सहमत हूँ। ये बातें मुझे {languages} में समझाई गईं, जो मैं समझता/समझती हूँ, और मैं यह सहमति अपनी मर्ज़ी से देता/देती हूँ। मैं कभी भी इसे वापस लेने के लिए कह सकता/सकती हूँ।',
      consentValue: 'प्लॉट से कटाई और बिक्री के लिए सहमति',
    },
    family: {
      title: 'परिवार की साझा ज़मीन वाले प्लॉट के लिए परिवार के सदस्यों की सहमति',
      heading: 'परिवार के सदस्यों की सहमति',
      about: 'प्लॉट {plot} परिवार की साझा ज़मीन है, या विरासत में मिला है और अभी बँटा नहीं है। {name} इसे {org} के साथ पंजीकृत कर रहे हैं। नीचे लिखे परिवार के सदस्य पुष्टि करते हैं कि उन्हें इसकी जानकारी है और वे इससे सहमत हैं।',
      agreeLead: 'हम, नीचे लिखे परिवार के सदस्य, सहमत हैं कि',
      obligations: [
        '{name} इस प्लॉट को {org} के साथ पंजीकृत कर सकते हैं, इसका नक्शा बनवा सकते हैं और निगरानी करवा सकते हैं, और इसे उन कार्यक्रमों में शामिल कर सकते हैं जिनके लिए {name} ने सहमति दी है।',
        '{name} इस प्लॉट पर कटाई की योजना बना सकते हैं और कटाई कर सकते हैं, और इसकी उपज {org} के ज़रिए बेच सकते हैं।',
        'इस प्लॉट की उपज का भुगतान {name} को किया जा सकता है; परिवार में इसे कैसे बाँटा जाए, यह परिवार का अपना मामला है।',
        'इस प्लॉट के बँटवारे, बिक्री, गिरवी या इससे जुड़े किसी भी विवाद के बारे में, और इसके धारक में किसी भी बदलाव के बारे में हम {org} को बताएँगे।',
        'जब तक यह सहमति लागू है, हममें से कोई भी इस प्लॉट की उपज अलग से नहीं काटेगा या बेचेगा, और न ही इसे किसी और के साथ पंजीकृत करेगा।',
        'इस सहमति के साथ हमारे नाम, {name} से हमारा रिश्ता और हमारे संपर्क नंबर दर्ज किए जा सकते हैं।',
      ],
      rightsLead: 'हम समझते हैं कि',
      rights: [
        'इस सहमति से यह नहीं बदलता कि ज़मीन का मालिक कौन है या उसमें किसका कितना हिस्सा है।',
        'हममें से कोई भी यह सहमति वापस लेने के लिए कह सकता है; तब {org} देखेगा कि प्लॉट पंजीकृत रह सकता है या नहीं।',
        'हममें से हर कोई माँगने पर, {name} या {org} के ज़रिए, प्लॉट के रिकॉर्ड, कटाई और बिक्री देख सकता है।',
      ],
      agree: 'ऊपर लिखे हम परिवार के सदस्यों को, और मुझे, {name}, यह सहमति {languages} में समझाई गई, जो हम समझते हैं, और हम यह सहमति अपनी मर्ज़ी से देते हैं।',
      consentValue: 'प्लॉट के लिए परिवार के सदस्यों की सहमति',
    },
    sharecrop: {
      title: 'प्लॉट के लिए भूमि मालिक और बटाईदार की सहमति',
      heading: 'भूमि मालिक और बटाईदार की सहमति',
      about: 'प्लॉट {plot} पर बटाई की व्यवस्था (bargadar / adhiar) के तहत खेती होती है। प्लॉट को {org} के साथ पंजीकृत करने, उस पर कटाई करने और उसकी उपज बेचने से पहले नीचे लिखे भूमि मालिक और बटाईदार दोनों सहमति देते हैं।',
      agreeLead: 'हम, भूमि मालिक और बटाईदार, सहमत हैं कि',
      obligations: [
        'प्लॉट को {org} के साथ पंजीकृत किया जा सकता है, इसका नक्शा बनाया और निगरानी की जा सकती है, और इसे उन कार्यक्रमों में शामिल किया जा सकता है जिनके लिए इसकी सहमति दी गई है।',
        'उपज में, या बिक्री की रकम में, हिस्सा वैसा ही होगा जैसा नीचे की शर्तों में लिखा है; {org} बिक्री के रिकॉर्ड पर हर व्यक्ति का हिस्सा दिखाएगा।',
        'कटाई की योजना और कटाई बटाईदार, भूमि मालिक की जानकारी में, {org} के आंतरिक कटाई परमिट और क़ानून के अनुसार ज़रूरी हर परमिट के साथ करेगा।',
        'प्लॉट की उपज {org} के ज़रिए बेची जाएगी, इसी प्लॉट के नाम पर दर्ज होगी, और उसमें कहीं और की उपज कभी नहीं मिलाई जाएगी।',
        'भुगतान नीचे की शर्तों के अनुसार होगा: हममें से हर एक को उसका हिस्सा, या उस व्यक्ति को जिसका नाम भुगतान पाने के लिए लिखा है।',
        'व्यवस्था में कोई भी बदलाव, कोई भी विवाद, या व्यवस्था ख़त्म होने पर हममें से कोई भी तुरंत {org} को बताएगा।',
      ],
      rightsLead: 'हम समझते हैं कि',
      rights: [
        'यह सहमति केवल व्यवस्था को दर्ज करती है; इससे ज़मीन का मालिकाना हक़ नहीं बदलता, और न ही क़ानून के तहत बटाईदार का कोई अधिकार।',
        'हममें से हर कोई प्लॉट की कटाई और बिक्री के रिकॉर्ड और हर बिक्री में अपना हिस्सा देख सकता है।',
        'हममें से कोई भी यह सहमति वापस लेने के लिए कह सकता है; तब {org} देखेगा कि प्लॉट पंजीकृत रह सकता है या नहीं।',
      ],
      agree: 'ऊपर लिखे हम भूमि मालिक और बटाईदार को यह सहमति {languages} में समझाई गई, जो हम समझते हैं, और हम यह सहमति अपनी मर्ज़ी से देते हैं।',
      consentValue: 'प्लॉट के लिए भूमि मालिक और बटाईदार की सहमति',
    },
    representative: {
      title: 'प्रतिनिधि नियुक्त करने के लिए किसान की सहमति',
      heading: 'प्रतिनिधि',
      about: '{name} नीचे लिखे व्यक्ति को {org} के साथ अपनी ओर से काम करने के लिए नियुक्त करते हैं - केवल नीचे टिक किए गए कामों में और केवल लिखे गए प्लॉट के लिए।',
      agreeLead: 'मैं सहमत हूँ कि',
      obligations: [
        'मेरा प्रतिनिधि केवल ऊपर टिक किए गए कामों में और केवल लिखे गए प्लॉट के लिए काम करेगा; बाकी हर बात के लिए मेरी ज़रूरत रहेगी।',
        'इन कामों में मेरा प्रतिनिधि जो भी पुष्टि करेगा, वह मुझ पर वैसे ही लागू होगी जैसे मैंने ख़ुद पुष्टि की हो।',
        '{org} इन कामों के संदेश और कोड मेरे प्रतिनिधि को उनके अपने मोबाइल नंबर पर भेज सकता है।',
        'अगर मेरे प्रतिनिधि को अब मेरी ओर से काम नहीं करना चाहिए, तो मैं यह तुरंत {org} को बताऊँ।',
      ],
      rightsLead: 'मैं समझता/समझती हूँ कि',
      rights: [
        'सदस्य और अपने प्लॉटों का धारक मैं ही रहता/रहती हूँ; प्रतिनिधि नियुक्त करने से मेरी ज़मीन, मेरी उपज या मेरे भुगतान किसी और के नाम नहीं हो जाते।',
        'मेरी उपज का भुगतान मेरे अपने ही बैंक खाते में होगा, जब तक मैं लिखकर कुछ और न कहूँ।',
        'मैं यह नियुक्ति कभी भी ख़त्म कर सकता/सकती हूँ; यह ज़्यादा से ज़्यादा दिखाई गई तारीख़ को ख़त्म हो जाती है।',
      ],
      agree: 'मैं, {name}, अपने प्रतिनिधि को इन शर्तों पर नियुक्त करता/करती हूँ, और मेरा प्रतिनिधि इन्हें स्वीकार करता/करती है। ये शर्तें हमें {languages} में समझाई गईं, जो हम समझते हैं, और हम यह सहमति अपनी मर्ज़ी से देते हैं।',
      consentValue: 'प्रतिनिधि की नियुक्ति',
      powersHeading: 'वे काम जिनमें प्रतिनिधि मेरी ओर से काम कर सकता है',
      powers: {
        acknowledge: 'मेरी ओर से सहमतियों और रिकॉर्ड की पुष्टि करना, अपने मोबाइल पर भेजे गए कोड से',
        confirmSale: 'मेरी बिक्री की मात्रा और रकम की पुष्टि करना',
        receivePayment: 'मेरे भुगतानों की सूचनाएँ पाना',
      },
      plotsAll: 'मेरे सभी प्लॉट',
      plotsSome: 'प्लॉट: {plots}',
    },
    dataProcessing: {
      title: 'किसान की अपनी जानकारी लेने और इस्तेमाल करने के लिए सहमति',
      heading: 'मेरी जानकारी',
      about: '{org} {name} के बारे में जानकारी लेता और रखता है, ताकि उन्हें सदस्य के रूप में पंजीकृत कर सके और उन कार्यक्रमों, बिक्री और भुगतानों को चला सके जिनमें वे भाग लेते हैं। यह सहमति उस जानकारी और उसके इस्तेमाल के लिए है।',
      agreeLead: 'मैं सहमत हूँ कि',
      obligations: [
        '{org} मेरा नाम, परिवार का विवरण, पता, फ़ोन और ईमेल, फ़ोटो, पहचान पत्र और भूमि के दस्तावेज़ों के नंबर (छिपाकर रखे गए), और मेरे प्लॉट, कटाई, बिक्री और भुगतानों का विवरण ले सकता है।',
        'इस जानकारी का इस्तेमाल मुझे पंजीकृत करने, मेरी पहचान और मेरी ज़मीन की जाँच करने, मेरे कार्यक्रम चलाने, और मेरी उपज को दर्ज करने और उसका भुगतान करने के लिए किया जा सकता है।',
        'इसे केवल उतना ही साझा किया जा सकता है जितना हर कार्यक्रम, बिक्री या दस्तावेज़ के लिए मेरी दी गई सहमतियाँ अनुमति दें, और सरकारी अधिकारियों के साथ जहाँ क़ानून के अनुसार ज़रूरी हो।',
        'मैं अपना विवरण सही और नया रखूँगा/रखूँगी, और बदलने पर {org} को बताऊँगा/बताऊँगी।',
      ],
      rightsLead: 'मुझे यह अधिकार है',
      rights: [
        'अपने बारे में रखी गई जानकारी देखना, और उसे ठीक या पूरा करवाना।',
        'जब किसी क़ानून या कार्यक्रम को उसकी ज़रूरत न रहे, तब उसे मिटवाना।',
        'कभी भी यह सहमति वापस लेना; जो जानकारी पहले ही इस्तेमाल हो चुकी है, वह क़ानून या कार्यक्रम के अनुसार ज़रूरी होने पर रखी जा सकती है।',
        'अपनी ओर से काम करने के लिए किसी व्यक्ति का नाम देना, और अगर मेरी चिंता का समाधान न हो तो भारत के डेटा संरक्षण बोर्ड (Data Protection Board of India) से शिकायत करना।',
      ],
      agree: 'मैं, {name}, सहमत हूँ कि मेरी जानकारी ऊपर बताए अनुसार ली और इस्तेमाल की जाए। यह मुझे {languages} में समझाई गई, जो मैं समझता/समझती हूँ, और मैं यह सहमति अपनी मर्ज़ी से देता/देती हूँ।',
      consentValue: 'जानकारी लेने और इस्तेमाल करने की सहमति',
    },
    trading: {
      title: 'किसान की किसान उत्पादक समूह के ज़रिए अपनी उपज बेचने के लिए सहमति',
      heading: 'अपनी उपज बेचना',
      about: '{name} अपनी उपज {org} के ज़रिए बेचते हैं। यह सहमति इस बारे में है कि बिक्री कैसे होगी, कैसे दर्ज होगी, उसकी पुष्टि कैसे होगी और भुगतान कैसे होगा।',
      agreeLead: 'मैं सहमत हूँ कि मैं',
      obligations: [
        'जिस उपज पर प्रमाणन या वनों की कटाई से मुक्त (deforestation-free) होने का दावा है, उसे केवल {org} या उसके बताए ख़रीदार को ही बेचूँ, और उसमें कहीं और की उपज कभी न मिलाऊँ।',
        'हर बिक्री इनवॉइस और डिस्पैच व ट्रांज़िट के काग़ज़ों के साथ दर्ज करवाऊँ, और उसकी मात्रा और रकम की पुष्टि अपने OTP या हस्ताक्षर से करूँ।',
        '{org} को उपज का पता लगाने के लिए बिक्री, उपज और वह कहाँ से आई, यह विवरण ख़रीदार, प्रमाणन संस्थाओं और सरकारी अधिकारियों के साथ साझा करने दूँ।',
        'तय की गई कटौतियाँ - अग्रिम राशि, खाद-बीज आदि के क़र्ज़, ढुलाई और समूह शुल्क - बिक्री की रकम से काटने दूँ, जैसा मेरे खाते के विवरण में दिखाया जाए।',
      ],
      rightsLead: 'मुझे यह अधिकार है',
      rights: [
        'हर बिक्री की पुष्टि करने से पहले उसका भाव, मात्रा, कटौतियाँ और मिलने वाली शुद्ध रकम जानना, और इनवॉइस की एक प्रति पाना।',
        'तय समय के अंदर अपने ही बैंक खाते में भुगतान पाना, और हर भुगतान अपने खाते के विवरण में देखना।',
        'जिस बिक्री का भाव या मात्रा मुझे मंज़ूर न हो, उसे मना करना।',
      ],
      agree: 'मैं, {name}, इससे सहमत हूँ। यह मुझे {languages} में समझाया गया, जो मैं समझता/समझती हूँ, और मैं यह सहमति अपनी मर्ज़ी से देता/देती हूँ। मैं कभी भी इसे वापस लेने के लिए कह सकता/सकती हूँ।',
      consentValue: 'किसान उत्पादक समूह के ज़रिए बेचने की सहमति',
    },
    documentShare: {
      title: 'किसान की अपने दस्तावेज़ साझा करने के लिए सहमति',
      heading: 'मेरे दस्तावेज़ साझा करना',
      about: '{org} को {name}, उनके प्लॉट या उनकी उपज के बारे में दस्तावेज़ किसी ख़रीदार, ऑडिटर या सरकारी अधिकारी को दिखाने पड़ सकते हैं। यह सहमति उन्हें एक सुरक्षित लिंक के ज़रिए साझा करने के लिए है।',
      agreeLead: 'मैं सहमत हूँ कि',
      obligations: [
        '{org} मेरे रिकॉर्ड और दस्तावेज़ों की प्रतियाँ - भूमि, प्रमाणन, कटाई, बिक्री और उपज का पता लगाने के दस्तावेज़ - हर बार साझा करते समय लिखे गए व्यक्ति के साथ, वहाँ लिखे गए उद्देश्य के लिए साझा कर सकता है।',
        'हर बार एक सुरक्षित लिंक भेजा जाता है जिसकी समय-सीमा ख़त्म हो जाती है, और उसे खोलने के लिए कोड की ज़रूरत पड़ सकती है।',
        'साझा किए गए दस्तावेज़ों पर पहचान के नंबर छिपाए जाते हैं, जब तक क़ानून के अनुसार पूरे नंबर ज़रूरी न हों।',
      ],
      rightsLead: 'मुझे यह अधिकार है',
      rights: [
        'यह जानना कि क्या साझा किया गया, किसके साथ और कब।',
        '{org} से कहना कि जो लिंक अभी तक खोला नहीं गया, उसे रोक दे।',
        'आगे साझा करने के लिए यह सहमति कभी भी वापस लेना।',
      ],
      agree: 'मैं, {name}, इससे सहमत हूँ। यह मुझे {languages} में समझाया गया, जो मैं समझता/समझती हूँ, और मैं यह सहमति अपनी मर्ज़ी से देता/देती हूँ। मैं कभी भी इसे वापस लेने के लिए कह सकता/सकती हूँ।',
      consentValue: 'दस्तावेज़ साझा करने की सहमति',
    },
    payment: {
      title: 'किसान की अपने भुगतान के तरीक़े के लिए सहमति',
      heading: 'मेरे भुगतान',
      about: '{org} {name} को उनकी उपज और सेवाओं का भुगतान करता है। यह सहमति इस बारे में है कि भुगतान कहाँ किया जाएगा और कैसे दर्ज होगा।',
      agreeLead: 'मैं सहमत हूँ कि',
      obligations: [
        'मेरे भुगतान रिकॉर्ड में दर्ज मेरे अपने ही बैंक खाते में होंगे, जब तक मैं लिखकर किसी दूसरे खाते की अनुमति न दूँ।',
        'तय की गई कटौतियाँ - अग्रिम राशि, खाद-बीज आदि के क़र्ज़, समूह शुल्क और क़ानून के अनुसार ज़रूरी कर - भुगतान से पहले काटी जा सकती हैं, और मेरे खाते के विवरण में दिखाई जाती हैं।',
        'मेरा बैंक खाता बदलने पर मैं तुरंत {org} को बताऊँगा/बताऊँगी, और हर भुगतान अपने खाते के विवरण में जाँचूँगा/जाँचूँगी।',
        'भुगतान की सूचनाएँ मेरे पंजीकृत मोबाइल, ईमेल या WhatsApp पर भेजी जा सकती हैं।',
      ],
      rightsLead: 'मुझे यह अधिकार है',
      rights: [
        'खाते का ऐसा विवरण पाना जिसमें हर बकाया रकम, हर कटौती और हर भुगतान दिखे।',
        'किसी भी भुगतान या कटौती पर सवाल उठाना और उसका कारण समझना।',
        'कभी भी यह सहमति वापस लेना; जो भुगतान हो चुके हैं, वे बने रहेंगे।',
      ],
      agree: 'मैं, {name}, इससे सहमत हूँ। यह मुझे {languages} में समझाया गया, जो मैं समझता/समझती हूँ, और मैं यह सहमति अपनी मर्ज़ी से देता/देती हूँ। मैं कभी भी इसे वापस लेने के लिए कह सकता/सकती हूँ।',
      consentValue: 'भुगतान की सहमति',
    },
    membership: {
      title: 'किसान की किसान उत्पादक समूह की सदस्यता के लिए सहमति',
      heading: 'सदस्यता',
      about: '{name} {org} के किसान उत्पादक समूह में शामिल होते हैं। यह सहमति इस बारे में है कि सदस्यता का उनके लिए क्या मतलब है।',
      agreeLead: 'सदस्य के रूप में, मैं सहमत हूँ कि मैं',
      obligations: [
        'समूह के नियमों और जिन कार्यक्रमों में मैं शामिल हूँ उनकी शर्तों का पालन करूँ, और उसके प्रशिक्षण, निरीक्षण और बैठकों में भाग लूँ।',
        'सच्चे रिकॉर्ड रखूँ, और कहीं और की उपज को कभी अपनी उपज बताकर न दूँ।',
        'अपनी ज़मीन, उसके स्वामित्व या उसके इस्तेमाल में कोई भी बदलाव {org} को बताऊँ।',
      ],
      rightsLead: 'सदस्य के रूप में, मुझे यह अधिकार है',
      rights: [
        'समूह के कार्यक्रमों और बिक्री में भाग लेना, और समूह के उन फ़ैसलों के बारे में जानना जिनका मुझ पर असर पड़ता है।',
        'कोई चिंता या शिकायत उठाना, बिना इसके कि इससे मेरे साथ होने वाले व्यवहार पर कोई असर पड़े।',
        'समूह छोड़ना; {org} बताएगा कि इसका मेरे कार्यक्रमों और बिक्री पर क्या असर होगा।',
      ],
      agree: 'मैं, {name}, इससे सहमत हूँ। यह मुझे {languages} में समझाया गया, जो मैं समझता/समझती हूँ, और मैं यह सहमति अपनी मर्ज़ी से देता/देती हूँ। मैं कभी भी इसे वापस लेने के लिए कह सकता/सकती हूँ।',
      consentValue: 'सदस्यता की सहमति',
    },
    portalAccess: {
      title: 'किसान की ऑनलाइन पोर्टल इस्तेमाल करने के लिए सहमति',
      heading: 'ऑनलाइन पहुँच',
      about: '{org} {name} को अपने रिकॉर्ड ऑनलाइन देखने की सुविधा देता है; वे अपने पंजीकृत मोबाइल या ईमेल पर भेजे गए कोड से लॉग इन करते हैं।',
      agreeLead: 'मैं सहमत हूँ कि मैं',
      obligations: [
        'मुझे भेजे गए कोड गुप्त रखूँ और उन्हें कभी किसी को न बताऊँ, {org} के कर्मचारियों को भी नहीं।',
        'पोर्टल का इस्तेमाल केवल अपने रिकॉर्ड के लिए करूँ, और अगर मुझे लगे कि किसी और ने मेरी पहुँच का इस्तेमाल किया है तो तुरंत {org} को बताऊँ।',
        'मेरे खाते को सुरक्षित रखने के लिए {org} को यह दर्ज करने दूँ कि मैंने कब और कहाँ से लॉग इन किया।',
      ],
      rightsLead: 'मुझे यह अधिकार है',
      rights: [
        'अपने रिकॉर्ड, प्लॉट, कटाई, बिक्री, भुगतान और सहमतियाँ ऑनलाइन देखना।',
        'माँगने पर कभी भी अपनी पहुँच बंद करवाना।',
      ],
      agree: 'मैं, {name}, इससे सहमत हूँ। यह मुझे {languages} में समझाया गया, जो मैं समझता/समझती हूँ, और मैं यह सहमति अपनी मर्ज़ी से देता/देती हूँ। मैं कभी भी इसे वापस लेने के लिए कह सकता/सकती हूँ।',
      consentValue: 'पोर्टल इस्तेमाल करने की सहमति',
    },
    harvestRequest: {
      title: 'किसान की अपने प्लॉट पर कटाई के लिए सहमति',
      heading: 'कटाई',
      about: '{name} {org} से अपने प्लॉट पर कटाई की व्यवस्था करने या अनुमति देने के लिए कहते हैं। यह सहमति इस बारे में है कि कटाई की योजना कैसे बनेगी, कटाई कैसे होगी और कैसे दर्ज होगी।',
      agreeLead: 'मैं सहमत हूँ कि मैं',
      obligations: [
        'केवल निशान लगे पेड़ और तय मात्रा ही काटूँ, {org} के आंतरिक कटाई परमिट और क़ानून के अनुसार ज़रूरी हर परमिट के साथ।',
        'कटाई को नापने, फ़ोटो लेने और मेरे प्लॉट के नाम पर दर्ज करने दूँ, और कटाई के बाद जगह की जाँच होने दूँ।',
        'प्रबंधन योजना के अनुसार दोबारा पेड़ लगाऊँ या प्राकृतिक रूप से उगने दूँ।',
      ],
      rightsLead: 'मुझे यह अधिकार है',
      rights: [
        'कटाई शुरू होने से पहले यह जानना कि कौन से पेड़ निशान लगाए गए हैं और अनुमानित मात्रा कितनी है।',
        'अपने प्लॉट की कटाई का रिकॉर्ड और उपज का विवरण देखना।',
      ],
      agree: 'मैं, {name}, इससे सहमत हूँ। यह मुझे {languages} में समझाया गया, जो मैं समझता/समझती हूँ, और मैं यह सहमति अपनी मर्ज़ी से देता/देती हूँ। मैं कभी भी इसे वापस लेने के लिए कह सकता/सकती हूँ।',
      consentValue: 'कटाई की सहमति',
    },
    eudrClaim: {
      title: 'किसान की अपनी उपज पर EUDR और FSC दावों के लिए सहमति',
      heading: 'मेरी उपज पर दावे',
      about: '{org} {name} के प्लॉटों की उपज EUDR के वनों की कटाई से मुक्त (deforestation-free) होने के दावे या FSC दावे के साथ बेचता है। यह सहमति उस जानकारी के लिए है जिसकी इन दावों को ज़रूरत होती है।',
      agreeLead: 'मैं सहमत हूँ कि',
      obligations: [
        'मेरे प्लॉटों का भौगोलिक स्थान (GPS), और मेरी कटाई और बिक्री के रिकॉर्ड, ड्यू डिलिजेंस विवरणों और दावों के रिकॉर्ड में ख़रीदारों और सरकारी अधिकारियों के साथ साझा किए जा सकते हैं।',
        'उपज दावे के साथ केवल तभी तक बेची जाती है जब तक मेरे प्लॉट शर्तें पूरी करते हैं, और मैं कहीं और की उपज अलग रखूँगा/रखूँगी।',
        'नियम के अनुसार यह जानकारी कम से कम पाँच साल तक रखी जा सकती है।',
      ],
      rightsLead: 'मुझे यह अधिकार है',
      rights: [
        'यह जानना कि मेरे प्लॉटों के बारे में क्या साझा किया गया, और किसके साथ।',
        'अगर मेरी उपज से कोई दावा हटाया जाए, तो यह और उसका कारण जानना।',
      ],
      agree: 'मैं, {name}, इससे सहमत हूँ। यह मुझे {languages} में समझाया गया, जो मैं समझता/समझती हूँ, और मैं यह सहमति अपनी मर्ज़ी से देता/देती हूँ। मैं कभी भी इसे वापस लेने के लिए कह सकता/सकती हूँ।',
      consentValue: 'EUDR और FSC दावों की सहमति',
    },
    withdrawal: {
      title: 'किसान द्वारा सहमति वापस लेना',
      heading: 'सहमति वापस लेना',
      about: '{name} नीचे दिखाए गए प्लॉटों या सदस्यता के लिए {org} को दी गई अपनी सहमति वापस लेते हैं।',
      agreeLead: 'मैं समझता/समझती हूँ कि',
      obligations: [
        'जिस तारीख़ से यह लागू होगा, उस दिन से दिखाए गए प्लॉट कार्यक्रमों में शामिल नहीं रहेंगे, और {org} के ज़रिए उनसे कोई नई कटाई या बिक्री नहीं होगी।',
        'जो जानकारी पहले ही इस्तेमाल या साझा की जा चुकी है, वह क़ानून, प्रमाणन या कार्यक्रम के अनुसार ज़रूरी होने पर रखी जा सकती है।',
        'मेरे जो भुगतान बकाया हैं, वे पहले की तरह ही किए जाएँगे।',
      ],
      rightsLead: 'मुझे यह अधिकार है',
      rights: [
        'यह जानना कि सहमति वापस लेने का मेरी बिक्री, भुगतानों और कार्यक्रमों पर क्या असर होगा।',
        'बाद में नई सहमति के रूप में फिर से सहमति देना।',
      ],
      agree: 'मैं, {name}, ऊपर दिखाए अनुसार अपनी सहमति वापस लेता/लेती हूँ। यह मुझे {languages} में समझाया गया, जो मैं समझता/समझती हूँ, और मैं यह अपनी मर्ज़ी से करता/करती हूँ।',
      consentValue: 'सहमति वापस लेना',
      plots: 'जिन प्लॉटों से सहमति वापस ली गई',
      reason: 'कारण',
      effective: 'लागू होने की तारीख़',
      allPlots: 'सदस्यता और सभी प्लॉट',
    },
    amendment: {
      title: 'किसान की सहमति में संशोधन',
      heading: 'क्या बदलता है',
      about: 'केवल नीचे दी गई बातें बदलती हैं। हस्ताक्षरित सहमति का बाकी हर शब्द जैसा था वैसा ही रहता है।',
      agreeLead: 'क्या वैसा ही रहता है',
      obligations: [
        'प्लॉट, उसकी सीमा और उसके कोने, जैसे हस्ताक्षरित सहमति में दर्ज हैं।',
        '{org} मेरी जानकारी के साथ क्या कर सकता है, और किसके साथ साझा कर सकता है।',
        'कभी भी, बिना शुल्क, अपनी सहमति वापस लेने का मेरा अधिकार।',
      ],
      rightsLead: 'मुझे यह अधिकार है',
      rights: [
        'हस्ताक्षर से पहले यह संशोधन मुझे मेरी समझ की भाषा में पढ़कर सुनाया जाए।',
        'इसे मना करना: तब मेरी सहमति ठीक वैसी ही रहती है जैसी मैंने हस्ताक्षर की थी।',
      ],
      agree: 'मैं, {name}, पुष्टि करता/करती हूँ कि दिखाए गए बदलाव मैंने माँगे थे, वे मुझे {languages} में समझाए गए, और मैं उनसे सहमत हूँ। मेरी सहमति की बाकी सब बातें वैसी ही रहती हैं जैसी मैंने हस्ताक्षर की थीं।',
      consentValue: 'सहमति में संशोधन सं. {n}',
      numbered: 'संशोधन सं. {n}',
      originalHeading: 'वह सहमति जिसमें यह संशोधन है',
      consentAmended: 'संशोधित सहमति',
      givenOn: 'दी गई',
      askedFor: 'संशोधन माँगा गया',
      reason: 'कारण',
      item: 'मद', was: 'पहले', now: 'अब',
      changeItems: { mobile: 'मोबाइल', email: 'ईमेल', address: 'पता', valid_to: 'मान्य तक', scope_codes: 'यह सहमति किन कार्यक्रमों के लिए है', rights_holder: 'अधिकार धारक', other: 'अन्य' },
    },
  },
  genders: { female: 'महिला', male: 'पुरुष', other: 'अन्य', undisclosed: 'बताना नहीं चाहते' },
  commonRights: [
    'यह जानना कि मेरे प्लॉट पर क्या पाया गया और क्यों, और उसके बारे में कोई भी फ़ैसला होने से पहले अपना जवाब देना।',
    'कोई चिंता या शिकायत उठाना, बिना इसके कि इससे मेरे साथ होने वाले व्यवहार पर कोई असर पड़े।',
    'कभी भी अपनी सहमति वापस लेने के लिए कहना; {org} बताएगा कि इसका इस कार्यक्रम में मेरी भागीदारी पर क्या असर हो सकता है।',
  ],
  scopes: {
    FSC_FM: {
      title: 'FSC वन प्रबंधन (समूह प्रमाणन)',
      about: 'फ़ॉरेस्ट स्टीवर्डशिप काउंसिल (FSC) यह प्रमाणित करती है कि पेड़ ज़िम्मेदारी से उगाए और काटे जाते हैं। मेरा प्लॉट {org} के FSC समूह के सदस्य के रूप में प्रमाणित है।',
      obligations: [
        'अपनी ज़मीन पर क़ानून का पालन करूँ: भूमि अधिकार, पेड़ काटने और लकड़ी ले जाने के परमिट, कर, और मज़दूरों, वन्यजीवों और पानी की रक्षा करने वाले क़ानून।',
        'अपने प्लॉट के लिए किसान उत्पादक समूह की प्रबंधन योजना और नियमों का पालन करूँ; मुझसे माँगे गए रिकॉर्ड रखूँ; अपनी ज़मीन या उसके इस्तेमाल में कोई भी बदलाव किसान उत्पादक समूह को बताऊँ।',
        'पेड़ केवल किसान उत्पादक समूह के आंतरिक कटाई परमिट और ज़रूरी हो तो वन विभाग के परमिट के साथ ही काटूँ, केवल निशान लगे पेड़ ही काटूँ, और कटाई के बाद दोबारा पेड़ लगाऊँ या प्राकृतिक रूप से उगने दूँ।',
        'नालों और जलाशयों के किनारे, और उच्च संरक्षण मूल्य वाले, पवित्र और दफ़न स्थलों के चारों ओर सुरक्षा पट्टी (बफ़र) छोड़ूँ; दुर्लभ और संकटग्रस्त पौधों और जानवरों की रक्षा करूँ, और उनका शिकार न करूँ।',
        'प्राकृतिक जंगल को साफ़ न करूँ और न ही उसे बागान या किसी और इस्तेमाल में बदलूँ, और कोई भी जेनेटिकली मॉडिफ़ाइड (GM) पेड़ न लगाऊँ।',
        'FSC की अत्यधिक खतरनाक कीटनाशकों की सूची में दिया कोई भी रसायन इस्तेमाल न करूँ; अन्य रसायन केवल ज़रूरत होने पर, सुरक्षा उपकरण के साथ, सुरक्षित भंडारण और डिब्बों के सुरक्षित निपटान के साथ ही इस्तेमाल करूँ; अवशेष कभी न जलाऊँ।',
        'क़ानूनी कामकाजी उम्र से कम किसी बच्चे को काम पर न रखूँ, बंधुआ या जबरन मज़दूरी न कराऊँ, किसी से भेदभाव न करूँ, मज़दूरों के संगठन बनाने के अधिकार का सम्मान करूँ, कम से कम न्यूनतम मज़दूरी दूँ, और सुरक्षा उपकरण और प्राथमिक चिकित्सा के साथ मज़दूरों को सुरक्षित रखूँ।',
        'पड़ोसियों और समुदायों के रास्तों, पानी और वन उपज पर पारंपरिक अधिकारों का सम्मान करूँ, और विवादों को किसान उत्पादक समूह की प्रक्रिया से सुलझाऊँ।',
        'किसान उत्पादक समूह, प्रमाणन संस्था, FSC और उसकी मान्यता सेवा (ASI) को अपने प्लॉट पर आने दूँ, और उन्हें अपने रिकॉर्ड देखने दूँ।',
        '{org}, प्रमाणन संस्था या किसी सत्यापनकर्ता द्वारा बताई गई किसी भी टिप्पणी या सुधार कार्रवाई को तय समय के भीतर पूरा करूँ। मैं समझता/समझती हूँ कि अनसुलझी समस्याओं से संबंधित कार्यक्रम या दावे में मेरे प्लॉट या उपज के शामिल रहने पर असर पड़ सकता है।',
        'FSC दावे वाली उपज केवल किसान उत्पादक समूह के ज़रिए ही बेचूँ, जिसके इनवॉइस पर उसका प्रमाणपत्र कोड हो, और FSC का नाम या लोगो केवल उतना ही इस्तेमाल करूँ जितना किसान उत्पादक समूह अनुमति दे।',
      ],
      rights: [
        'जब तक मेरा प्लॉट नियमों पर खरा उतरता है, किसान उत्पादक समूह के ज़रिए अपनी उपज FSC दावे के साथ बेचना।',
        'किसान उत्पादक समूह के नियम और अपने प्लॉट की प्रबंधन योजना देखना।',
      ],
    },
    FSC_CW: {
      title: 'FSC नियंत्रित लकड़ी (सत्यापन)',
      about: 'जो लकड़ी FSC प्रमाणित नहीं है, वह भी FSC नियंत्रित लकड़ी (Controlled Wood) के रूप में बेची जा सकती है, जब यह सत्यापित हो जाए कि वह स्वीकार्य स्रोतों से आई है। मेरा प्लॉट इसके लिए सत्यापित है।',
      obligations: [
        'मेरे प्लॉट की लकड़ी क़ानूनी तरीके से काटी और ले जाई जाती है, क़ानून के हर ज़रूरी परमिट और कर के साथ।',
        'यह ऐसी ज़मीन से नहीं आती जहाँ पड़ोसियों, समुदायों या मज़दूरों के पारंपरिक, नागरिक या मानवाधिकारों का सम्मान नहीं होता।',
        'यह ऐसे क्षेत्रों से नहीं आती जिनके उच्च संरक्षण मूल्य कटाई से खतरे में हैं।',
        'यह ऐसे प्राकृतिक जंगल से नहीं आती जिसे बागान या किसी और इस्तेमाल में बदला जा रहा है।',
        'यह जेनेटिकली मॉडिफ़ाइड (GM) पेड़ों से नहीं आती।',
        'लकड़ी का हर लॉट कहाँ से आया - कौन सा प्लॉट, कौन सी प्रजाति और कितनी मात्रा - इसकी सही जानकारी दूँ, ताकि उसका पता लगाया जा सके।',
        '{org} और उसके सत्यापनकर्ताओं को अपने प्लॉट पर आने दूँ और अपनी ज़मीन, परमिट और कटाई के दस्तावेज़ देखने दूँ, और उन्हें किसी भी बदलाव के बारे में बताऊँ।',
      ],
      rights: ['जब तक सत्यापन बना रहता है, {org} के ज़रिए अपनी लकड़ी FSC नियंत्रित लकड़ी के रूप में बेचना।'],
    },
    EUDR: {
      title: 'यूरोपीय संघ वनों की कटाई विनियमन (EUDR)',
      about: 'यूरोपीय संघ में बेची जाने वाली लकड़ी और अन्य उत्पादों के बारे में यह साबित करना ज़रूरी है कि वे 31 दिसंबर 2020 के बाद हुई वनों की कटाई से मुक्त हैं और क़ानूनी तरीके से पैदा किए गए हैं। {org} एक ड्यू डिलिजेंस (सम्यक जाँच) विवरण दाखिल करता है जिसमें मेरा प्लॉट शामिल है।',
      obligations: [
        'अपने प्लॉट की सीमा (उसकी भौगोलिक स्थिति) को दर्ज करने, और ड्यू डिलिजेंस विवरणों में खरीदारों और यूरोपीय संघ के अधिकारियों के साथ साझा करने की अनुमति दूँ।',
        '31 दिसंबर 2020 के बाद अपने प्लॉट को वनों की कटाई और वनों के क्षरण से मुक्त रखूँ।',
        'भारत के क़ानूनों के तहत क़ानूनी तरीके से उत्पादन करूँ: भूमि उपयोग के अधिकार, पर्यावरण और वन नियम, ज़मीन पर दूसरों के अधिकार, श्रम और मानवाधिकार, जहाँ लागू हो वहाँ स्वतंत्र, पूर्व और सूचित सहमति, कर, भ्रष्टाचार-विरोधी, व्यापार और सीमा शुल्क।',
        'अपनी ज़मीन, अपनी कटाई और अपनी उपज कहाँ जाती है, इसकी सही जानकारी दूँ, और इस प्लॉट की उपज को कहीं और की उपज से अलग रखूँ।',
        'प्लॉट की सीमा, उपयोग या स्वामित्व में किसी भी बदलाव, और उस पर किसी भी सफ़ाई (पेड़ हटाने) के बारे में {org} को तुरंत बताऊँ।',
        '{org} को यह जानकारी, विनियमन की माँग के अनुसार, कम से कम पाँच साल तक रखने और अधिकारियों को दिखाने की अनुमति दूँ।',
      ],
      rights: ['यह जानना कि मेरे प्लॉट के बारे में क्या साझा किया जाता है, और किसके साथ।'],
    },
    GLOBALGAP: {
      title: 'GLOBALG.A.P. (अच्छी कृषि पद्धति)',
      about: 'GLOBALG.A.P. खुदरा विक्रेताओं को बेचे जाने वाले भोजन और पौधों के लिए सुरक्षित और टिकाऊ खेती को प्रमाणित करता है। मेरा प्लॉट {org} के समूह प्रमाणपत्र में शामिल है।',
      obligations: [
        'किसान उत्पादक समूह की गुणवत्ता प्रबंधन प्रणाली और नियमों का पालन करूँ, और हर साल उसके आंतरिक निरीक्षणों में भाग लूँ।',
        'मैं क्या बोता/बोती हूँ, कौन से इनपुट कब डालता/डालती हूँ, और मेरी कटाई का रिकॉर्ड रखूँ, ताकि हर लॉट का पता मेरे प्लॉट तक लगाया जा सके; प्रमाणित और अन्य उपज को अलग रखूँ।',
        'केवल उस फ़सल के लिए स्वीकृत पौध संरक्षण उत्पाद ही, सही मात्रा में, प्रशिक्षित व्यक्ति द्वारा सुरक्षा उपकरण के साथ डलवाऊँ, और कटाई से पहले की प्रतीक्षा अवधि का पालन करूँ; उन्हें ताले में रखूँ और डिब्बों का सुरक्षित निपटान करूँ।',
        'खाद के इस्तेमाल का रिकॉर्ड रखूँ; मानव मल-जल की गाद (सीवेज स्लज) का इस्तेमाल न करूँ; ऐसा पानी इस्तेमाल करूँ जो उसके काम के लिए सुरक्षित हो।',
        'उपज, कटाई के औज़ार और डिब्बे साफ़ रखूँ, और तोड़ने वालों के लिए हाथ धोने और शौचालय की व्यवस्था रखूँ।',
        'मज़दूरों को सुरक्षित, प्रशिक्षित और जानकार रखूँ, प्राथमिक चिकित्सा, साफ़ पीने के पानी और उचित व्यवहार के साथ।',
        'कचरे और प्रदूषण को ठीक से संभालूँ; अपने प्लॉट पर और उसके आसपास मिट्टी, पानी और वन्यजीवों की रक्षा करूँ।',
        'किसी भी शिकायत, संदूषण या खाद्य सुरक्षा की समस्या के बारे में किसान उत्पादक समूह को तुरंत बताऊँ, और ज़रूरत पड़ने पर उपज वापस लेने (विदड्रॉल या रिकॉल) में भाग लूँ।',
        'किसान उत्पादक समूह के निरीक्षकों और प्रमाणन संस्था को अपने प्लॉट और रिकॉर्ड का निरीक्षण करने, और अवशेष जाँच के लिए नमूने लेने दूँ।',
      ],
      rights: ['जब तक मेरा प्लॉट नियमों पर खरा उतरता है, अपनी उपज GLOBALG.A.P. प्रमाणित के रूप में बेचना।'],
    },
    PEFC: {
      title: 'PEFC (टिकाऊ वन प्रबंधन)',
      about: 'PEFC टिकाऊ तरीके से प्रबंधित जंगलों और पेड़ों के खेतों को प्रमाणित करता है। मेरा प्लॉट {org} के किसान उत्पादक समूह के हिस्से के रूप में प्रमाणित है।',
      obligations: [
        'अपनी ज़मीन पर क़ानून का पालन करूँ, जिसमें वन, पर्यावरण, श्रम और कर क़ानून शामिल हैं, और पेड़ काटने और लकड़ी ले जाने के लिए ज़रूरी परमिट रखूँ।',
        'किसान उत्पादक समूह की योजना के अनुसार अपने पेड़ों का प्रबंधन करूँ: उन्हें उत्पादक और स्वस्थ रखूँ, जितना दोबारा उगता है उससे ज़्यादा न काटूँ, और दोबारा पेड़ लगाऊँ या प्राकृतिक रूप से उगने दूँ।',
        'जंगल को किसी और भूमि उपयोग में न बदलूँ, और कोई भी जेनेटिकली मॉडिफ़ाइड (GM) पेड़ न लगाऊँ।',
        'मिट्टी और पानी की रक्षा करूँ, नालों के किनारे सुरक्षा पट्टी (बफ़र) छोड़ूँ, और अपने प्लॉट पर जैव विविधता और पारिस्थितिक रूप से महत्वपूर्ण क्षेत्रों की रक्षा करूँ।',
        'अत्यंत या अत्यधिक खतरनाक श्रेणी का कोई भी कीटनाशक इस्तेमाल न करूँ; रसायन केवल ज़रूरत होने पर, सुरक्षित तरीके से और लेबल पर लिखे अनुसार ही इस्तेमाल करूँ।',
        'मज़दूरों के मौलिक अधिकारों का सम्मान करूँ - कोई बाल या बंधुआ/जबरन मज़दूरी नहीं, कोई भेदभाव नहीं, संगठन बनाने की आज़ादी - और उन्हें सुरक्षित रखूँ।',
        'स्थानीय समुदायों के अधिकारों का, और मेरे प्लॉट पर या उसके पास के सांस्कृतिक और धार्मिक स्थलों का सम्मान करूँ।',
        'मुझसे माँगे गए रिकॉर्ड रखूँ, किसान उत्पादक समूह और प्रमाणन संस्था के ऑडिट होने दूँ, और उनके द्वारा बताई गई किसी भी सुधार कार्रवाई को तय समय के भीतर पूरा करूँ।',
        'PEFC दावे वाली लकड़ी केवल किसान उत्पादक समूह के ज़रिए ही बेचूँ, और PEFC का नाम या लोगो केवल उतना ही इस्तेमाल करूँ जितना किसान उत्पादक समूह अनुमति दे।',
      ],
      rights: ['जब तक मेरा प्लॉट नियमों पर खरा उतरता है, किसान उत्पादक समूह के ज़रिए अपनी लकड़ी PEFC दावे के साथ बेचना।'],
    },
    ORGANIC: {
      title: 'जैविक (NPOP / NOP)',
      about: 'जैविक प्रमाणन यह दिखाता है कि उपज कृत्रिम (रासायनिक) खाद और कीटनाशकों के बिना उगाई गई है। मेरा प्लॉट {org} के जैविक उत्पादक समूह में, उसकी आंतरिक नियंत्रण प्रणाली के तहत शामिल है।',
      obligations: [
        'मेरी उपज जैविक के रूप में बेचे जाने से पहले रूपांतरण (कन्वर्ज़न) अवधि पूरी करूँ।',
        'कोई भी कृत्रिम खाद, कीटनाशक, खरपतवारनाशक या वृद्धि नियामक, कोई भी जेनेटिकली मॉडिफ़ाइड (GM) बीज या रोपण सामग्री, और कोई भी सीवेज स्लज (मल-जल की गाद) इस्तेमाल न करूँ।',
        'केवल वही इनपुट इस्तेमाल करूँ जिनकी जैविक मानक अनुमति देता है, और उनके बिल और लेबल संभालकर रखूँ।',
        'पड़ोस के पारंपरिक (रासायनिक) खेतों से सुरक्षा पट्टी (बफ़र) रखूँ, और उनसे छिड़काव के बहाव और संदूषण को रोकूँ।',
        'अगर मैं पारंपरिक फ़सलें भी उगाता/उगाती हूँ, तो उन्हें साफ़ तौर पर अलग रखूँ, और पारंपरिक उपज को कभी भी जैविक उपज में न मिलाऊँ।',
        'अपने इनपुट, कटाई और बिक्री का रिकॉर्ड रखूँ; जैविक उपज के लिए साफ़, अलग बोरे और भंडार इस्तेमाल करूँ।',
        'आंतरिक नियंत्रण प्रणाली के नियमों का पालन करूँ, उसके प्रशिक्षण में भाग लूँ, और उसके निरीक्षण और नमूना जाँच होने दूँ; मैं समझता/समझती हूँ कि कोई ज़रूरी शर्त पूरी न होने पर इस पर असर पड़ सकता है कि मेरी उपज जैविक के रूप में बेची जा सकती है या नहीं।',
        'उपज को जैविक के रूप में केवल किसान उत्पादक समूह के ज़रिए ही बेचूँ, और उस पर लेबल केवल उतना ही लगाऊँ जितना किसान उत्पादक समूह अनुमति दे।',
        'किसी भी प्रतिबंधित पदार्थ के इस्तेमाल, संदूषण, या अपनी ज़मीन में किसी भी बदलाव के बारे में किसान उत्पादक समूह को तुरंत बताऊँ।',
      ],
      rights: ['जब तक मेरा प्लॉट नियमों पर खरा उतरता है, किसान उत्पादक समूह के ज़रिए अपनी उपज जैविक के रूप में बेचना।'],
    },
    CARBON: {
      title: 'कार्बन परियोजना',
      about: 'मेरे प्लॉट के पेड़ कार्बन जमा करते हैं। {org} मेरे प्लॉट को एक कार्बन परियोजना में शामिल करता है जो इसे मापती है और इसके लिए कार्बन क्रेडिट बेच सकती है।',
      obligations: [
        'परियोजना समझौते में लिखे अनुसार, परियोजना की क्रेडिट अवधि के लिए, अपने प्लॉट पर परियोजना के पेड़ों से मिलने वाले कार्बन क्रेडिट का अधिकार परियोजना को सौंपूँ।',
        'परियोजना अवधि तक परियोजना के पेड़ों को खड़ा रखूँ; उनमें से किसी को भी काटने से पहले {org} को बताऊँ, और जो पेड़ मर जाएँ उनकी जगह नए लगाऊँ।',
        'उन्हीं पेड़ों या ज़मीन को किसी और कार्बन परियोजना या योजना में दर्ज न कराऊँ, और उनका कार्बन किसी और को न बेचूँ।',
        'जो सफ़ाई या कटाई मैं यहाँ करता/करती, उसे किसी दूसरी ज़मीन पर न ले जाऊँ (लीकेज)।',
        'परियोजना को पेड़ों को मापने, मेरे प्लॉट का नक्शा बनाने, और उपग्रह से उसकी निगरानी करने दूँ, और वे आँकड़े रजिस्ट्री, सत्यापनकर्ता और क्रेडिट के खरीदारों के साथ साझा करने दूँ।',
        'परियोजना के पेड़ों पर असर डालने वाली किसी भी आग, नुकसान, विवाद या स्वामित्व में बदलाव के बारे में {org} को बताऊँ।',
      ],
      rights: [
        'परियोजना समझौते में तय कार्बन आय का हिस्सा पाना, और यह देखना कि उसका हिसाब कैसे लगाया जाता है।',
        'परियोजना के लिए स्वतंत्र, पूर्व और सूचित सहमति देना, जो इस दस्तावेज़ के ज़रिए दी जा रही है।',
      ],
    },
  },
  membershipDuties: [
    'अपने प्लॉट के लिए कार्यक्रम की शर्तों का पालन करूँ, और अपनी ज़मीन, उसके स्वामित्व या उसके इस्तेमाल में किसी भी बदलाव के बारे में {org} को बताऊँ।',
    'प्रशिक्षण, आंतरिक निरीक्षणों और ऑडिट में भाग लूँ, और किसी भी सुधार कार्रवाई को तय समय के भीतर पूरा करूँ।',
    'मैं समझता/समझती हूँ कि हर कार्यक्रम की अपनी शर्तें होती हैं। {org} मेरे प्लॉट और रिकॉर्ड की समीक्षा कर सकता है ताकि यह तय किया जा सके कि मेरा प्लॉट और उपज लागू कार्यक्रम की शर्तों पर खरे उतरते रहते हैं या नहीं।',
    'यदि किसी भी शर्त का पालन नहीं किया जाता, तो मैं समझता/समझती हूँ कि {org} इसकी समीक्षा कर सकता है कि मेरा प्लॉट या उपज संबंधित कार्यक्रम या दावे में शामिल रह सकते हैं या नहीं।',
    'सही रिकॉर्ड रखूँ, और कहीं और की उपज को कभी भी अपने प्लॉट की उपज बताकर न दूँ।',
  ],
  dataNotice: {
    collected: 'मेरा नाम और परिवार का विवरण, पता, फ़ोन और ईमेल, पहचान पत्र और भूमि दस्तावेज़ों के नंबर (छिपाकर रखे जाते हैं), फ़ोटो, मेरे प्लॉट की सीमा और स्थान, उस पर लगे पेड़ और अपनाई गई पद्धतियाँ, और मेरी कटाई, बिक्री और भुगतान।',
    purposes: 'मेरा और मेरे प्लॉट का पंजीकरण करने, इस दस्तावेज़ में बताए गए कार्यक्रमों के तहत उसे प्रमाणित करने, मेरी उपज का पता लगाने और उसके दावों के साथ बेचने, ड्यू डिलिजेंस विवरण दाखिल करने, कार्बन मापने, और मुझे भुगतान करने के लिए।',
    sharedWith: 'जहाँ ज़रूरी हो: प्रमाणन संस्थाएँ, ऑडिटर, कार्यक्रम या मानक के मालिक, सत्यापनकर्ता, रजिस्ट्रियाँ, खरीदार, आपूर्ति-श्रृंखला भागीदार, परियोजना भागीदार और सरकारी अधिकारी। खरीदारों और आपूर्ति-श्रृंखला भागीदारों को केवल उतनी ही जानकारी मिलती है जितनी उपज का पता लगाने, सत्यापन, ड्यू डिलिजेंस, प्रमाणन या बिक्री के लिए उचित रूप से ज़रूरी हो। मेरी निजी जानकारी असंबंधित मार्केटिंग के लिए नहीं बेची जाएगी।',
    retention: 'जब तक यह सहमति बनी रहती है तब तक, और उसके बाद जब तक क़ानून या कोई कार्यक्रम माँगे तब तक (EUDR रिकॉर्ड के लिए कम से कम पाँच साल)।',
    rights: 'अपने बारे में रखा गया डेटा देखना, उसे सुधरवाना या पूरा करवाना, जब किसी क़ानून या कार्यक्रम को उसकी ज़रूरत न रहे तब उसे मिटवाना, कभी भी यह सहमति वापस लेने के लिए कहना, और अपनी ओर से काम करने के लिए किसी व्यक्ति को नामित करना।',
  },
  sharing: {
    intro: 'मैं सहमत हूँ कि {org} इस सहमति में बताए गए उद्देश्यों के लिए मेरे और मेरे प्लॉट के बारे में जानकारी ले सकता है, दर्ज कर सकता है, इस्तेमाल कर सकता है और रख सकता है। मैं {org} को अधिकार देता/देती हूँ कि वह मेरे, मेरे प्लॉट, उत्पादन, कटाई और लेन-देन के बारे में संबंधित जानकारी इनके साथ साझा करे:',
    recipients: [
      'प्रमाणन संस्थाएँ और ऑडिटर;',
      'कार्यक्रम के मालिक, मानक के मालिक और सत्यापन संगठन;',
      'सरकारी और नियामक अधिकारी, जहाँ ज़रूरी हो;',
      'खरीदार और आपूर्ति-श्रृंखला भागीदार, जहाँ जानकारी उपज का पता लगाने, दावे के सत्यापन, ड्यू डिलिजेंस या लेन-देन की शर्तों के लिए ज़रूरी हो;',
      'कार्बन परियोजना की रजिस्ट्रियाँ, सत्यापनकर्ता और संबंधित परियोजना भागीदार, जहाँ लागू हो; और',
      'नक्शा बनाने, निगरानी, डेटा प्रबंधन या सत्यापन में सहायता करने वाले सेवा प्रदाता।',
    ],
    limits: [
      'केवल वही जानकारी साझा की जाएगी जो लागू कार्यक्रम, दावे, सत्यापन, उपज का पता लगाने या लेन-देन से संबंधित हो।',
      '{org} मेरी निजी जानकारी असंबंधित मार्केटिंग के लिए नहीं बेचेगा।',
      'मैं समझता/समझती हूँ कि उपज का मूल स्थान और नियमों का पालन दिखाने के लिए मेरे प्लॉट के बारे में कुछ जानकारी, जैसे उसका स्थान, उत्पादन, कटाई और उपज का पता लगाने की जानकारी, साझा करनी पड़ सकती है।',
    ],
    statements: [
      'मैं सहमत हूँ कि जब उपज का मूल स्थान, उसका पता लगाने की क्षमता, प्रमाणन दावे, ड्यू डिलिजेंस या नियमों के पालन की शर्तें दिखाने के लिए ज़रूरी हो, तब मेरे प्लॉट और उपज के बारे में संबंधित जानकारी खरीदारों और आपूर्ति-श्रृंखला भागीदारों के साथ साझा की जा सकती है।',
      'मैं सहमत हूँ कि इस सहमति में शामिल उद्देश्यों के लिए फ़ोटो, प्लॉट के नक्शे, उत्पादन की जानकारी, कटाई की जानकारी और संबंधित रिकॉर्ड अधिकृत कार्यक्रम, प्रमाणन, सत्यापन और परियोजना संगठनों के साथ साझा किए जा सकते हैं।',
    ],
    withdrawal: 'मैं कभी भी अपनी सहमति वापस लेने के लिए कह सकता/सकती हूँ। {org} बताएगा कि सहमति वापस लेने का संबंधित कार्यक्रम, प्रमाणन, दावे या परियोजना में मेरी भागीदारी पर क्या असर हो सकता है। सहमति वापस लेने से पहले जो जानकारी इस्तेमाल या साझा की जा चुकी है, वह रिकॉर्ड, क़ानूनी, प्रमाणन, उपज का पता लगाने या कार्यक्रम की शर्तों के लिए ज़रूरी होने पर आगे भी रखी जा सकती है।',
  },
};
